export const welcomeToAccountManagerBillboardTemplate = /* html */ `
  <div class="tour-welcome-to-ams d-flex align-items-center justify-content-center position-relative p-4">
    <div class="mb-5">
      <header class="text-center mb-5">
        <h2 class="display-2 fw-semibold mb-4">{{title}}</h2>
        <h3>{{subtitle}}</h3>
      </header>

      <div class="row text-center mb-4">
        <div class="col-4 d-flex flex-column align-items-center">
          <object
            type="image/svg+xml"
            data="/assets/img/onboarding-save-data.svg"
            style="aspect-ratio: 700 / 463;"
            class="img-fluid w-100 mb-4 mx-auto rounded welcome-svg"
            aria-label="Illustration of creating lists"
          ></object>
          <div class="w-75">
            <h3 class="fs-1 fw-bold">
              {{feature1Emphasis}}
              <span class="fw-normal">{{feature1Regular}}</span>
            </h3>
          </div>
        </div>

        <div class="col-4 d-flex flex-column align-items-center">
          <object
            type="image/svg+xml"
            data="/assets/img/onboarding-connect.svg"
            style="aspect-ratio: 700 / 463;"
            class="img-fluid w-100 mb-4 mx-auto rounded welcome-svg"
            aria-label="Illustration of distributing licenses to a fleet"
          ></object>
          <div class="w-75">
            <h3 class="fs-1 fw-bold">
              <span class="fw-normal">{{feature2RegularPrefix}}</span
              >{{feature2Emphasis}}<span class="fw-normal">
                {{feature2RegularSuffix}}</span
              >
            </h3>
          </div>
        </div>

        <div class="col-4 d-flex flex-column align-items-center">
          <object
            type="image/svg+xml"
            data="/assets/img/onboarding-routing-profile.svg"
            style="aspect-ratio: 700 / 463;"
            class="img-fluid w-100 mb-4 mx-auto rounded welcome-svg"
            aria-label="Illustration of re-assigning licenses"
          ></object>
          <div class="w-75">
            <h3 class="fs-1 fw-bold">
              {{feature3Emphasis}}
              <span class="fw-normal">{{feature3Regular}}</span>
            </h3>
          </div>
        </div>
      </div>
    </div>

    <div class="position-absolute bottom-0 end-0">
      <button
        type="button"
        class="btn btn-primary btn-lg px-4"
        data-tour-action-key="nextButton"
      ></button>
    </div>
  </div>
`;
